import React from 'react';

import BasicDialog from '../../components/basicDialog/BasicDialog';
import DeleteAccountForm from './components/DeleteAccountForm';

interface IProps {
  isOpen: boolean;
  handleClose: () => void;
}

const DeleteAccountDialog: React.FC<IProps> = ({
  isOpen = true,
  handleClose,
}) => {
  return (
    <BasicDialog maxWidth="30rem" isOpen={isOpen} handleClose={handleClose}>
      <DeleteAccountForm handleClose={handleClose} />
    </BasicDialog>
  );
};

export default DeleteAccountDialog;
